import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store/index.js';

// createApp(App).use(store).use(router).use(VueGeolocation).mount('#app');
createApp(App).use(store).use(router).mount('#app');
